import type { ModuleConfig } from "../modules/types"
import type { ModuleType } from "../modules/types"
import { DASHBOARD_EVENTS } from "./events"

interface AnalyticsWithTrack { track: (eventName: string, payload: Record<string, unknown>) => void }

export function trackDashboardModuleAdded(
  analytics: AnalyticsWithTrack,
  moduleType: ModuleType,
  config: ModuleConfig,
) {
  analytics.track(DASHBOARD_EVENTS.MODULE_ADDED, {
    moduleType,
    ...config,
  })
}
